module.exports = __webpack_public_path__ + "static/media/xz01_grey.6f8d17ca.png";